import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import './fonts/fonts.css';

import ControlPanel from './pages/ControlPanel/ControlPanel';
import GameEditor from './pages/GameEditor/GameEditor';
import Game from './pages/Game/Game';
import Home from './pages/Home/Home';

const pages: Record<string, {title: string, component: React.ComponentClass}> = {
	'/': {
		title: 'Jeopardy! Home Page',
		component: Home,
	},
	'/game': {
		title: 'Jeopardy!',
		component: Game,
	},
	'/control-panel': {
		title: 'Jeopardy! Control Panel',
		component: ControlPanel,
	},
	'/questions': {
		title: 'Jeopardy! Question Editor',
		component: GameEditor,
	},
};

const page = pages[window.location.pathname];
if (page) {
	document.title = page.title;
	ReactDOM.render(
		<React.StrictMode>
			<page.component />
		</React.StrictMode>,
		document.getElementById('root'),
	);
} else {
	window.location.pathname = '';
}
